import App from './App.vue'
import router from './router'
import { setupStore } from '@/store'
// import ElementPlus from 'element-plus'
import { useI18n } from '@/plugins/i18n'
import { getServerConfig } from './config'
import { createApp, Directive } from 'vue'
import { MotionPlugin } from '@vueuse/motion'
// import { useEcharts } from "@/plugins/echarts";
import { injectResponsiveStorage } from '@/utils/responsive'
const { version } = require('./../package.json') // 获取版本号
sessionStorage.setItem('version', version)

// 引入重置样式
import './style/reset.scss'
// 导入公共样式
import './style/index.scss'
// 一定要在main.ts中导入tailwind.css
import './style/tailwind.css'
import 'element-plus/dist/index.css'
// 导入字体图标
import './assets/iconfont/iconfont.js'
import './assets/iconfont/iconfont.css'

// 自定义指令
import * as directives from '@/directives'

// 全局注册`@iconify/vue`图标库
import {
  IconifyIconOffline,
  IconifyIconOnline,
  FontIcon
} from './components/ReIcon'

// 全局注册按钮级别权限组件
import { Auth } from '@/components/ReAuth'

const app = createApp(App)
Object.keys(directives).forEach((key) => {
  app.directive(key, (directives as { [key: string]: Directive })[key])
})
app.component('IconifyIconOffline', IconifyIconOffline)
app.component('IconifyIconOnline', IconifyIconOnline)
app.component('FontIcon', FontIcon)
app.component('Auth', Auth)

const debounce = (fn: any, delay: any) => {
  let timer = null
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    // eslint-disable-next-line prefer-rest-params
    const args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}
getServerConfig(app).then(async (config) => {
  app.use(router)
  await router.isReady()
  injectResponsiveStorage(app, config)
  setupStore(app)
  app.use(MotionPlugin).use(useI18n)
  app.mount('#mainApp')
})
